<h3 mat-dialog-title>
    Verify Microdeposits
</h3>
<img (click)="closeDialog()" class="mat-close" src="/assets/images/payhoa/other/icon_close.svg">

<mat-dialog-content>
    <p>
        In order to verify your checking account information, <b>we send two small deposits to your checking
        account</b>
        and then ask that you report the deposit amounts back to us.
    </p>
    <p>
        This only occurs the first time you pay from an account to verify your ownership.
    </p>
    <p class="mb-5">
        The micro deposits typically <b>take one or two business days to post</b> to your checking account.
    </p>

    <!-- show them action buttons, not the inputs, to avoid random input values -->
    <div *ngIf="isShowingInfo && !isShowingInputs" class="card mb-0">
        <div class="card-header">
            <h2>Do you see 2 small deposits in your bank account?</h2>
        </div>
        <div class="card-body">
            <div *ngIf="!isShowingWaitLater" class="d-flex justify-content-between">
                <button (click)="isShowingWaitLater = true" class="btn btn-link">
                    No, I don't see them yet
                </button>

                <button (click)="isShowingInputs = true" class="btn btn-link">
                    Yes, I see two small deposits in my bank account
                </button>
            </div>
            <p *ngIf="isShowingWaitLater" class="mb-0">Ok! Glad we asked. <b>Once you see two small deposits
                in
                your account (1-2 days), come back here to enter the amounts so your account can be
                verified.</b></p>
        </div>
    </div>

    <div *ngIf="isShowingInputs" class="card mb-0">
        <div class="card-header">
            <h2>Confirm the 2 micro-deposit amounts</h2>
        </div>
        <div class="card-body">
            <p>
                <b>Do not enter any amounts until you see the deposit amounts in your checking account.</b>
            </p>
            <p>
                3 incorrect attempts will require you to start the process over.
            </p>
            <p>
                **Most savings accounts are not supported for ACH payment. Please ensure that your bank
                account is a checking account.**
            </p>

            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <label>Deposit 1:</label>
                    <lf-currency [(ngModel)]="depositAmounts[0]"
                                 [showSymbol]="true"
                                 ngDefaultControl
                                 required></lf-currency>
                </div>

                <div class="col-md-6 col-sm-12">
                    <label>Deposit 2:</label>
                    <lf-currency [(ngModel)]="depositAmounts[1]"
                                 [showSymbol]="true"
                                 ngDefaultControl
                                 required></lf-currency>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button (click)="closeDialog()" class="btn btn-outline-secondary">
        Cancel
    </button>
    <button (click)="verifyMicrodeposits();"
            *ngIf="isShowingInputs"
            [disabled]="!(!requestInFlight && depositAmounts[0] > 0 && depositAmounts[1] > 0)"
            class="btn btn-primary">
        Verify
    </button>
</mat-dialog-actions>
